import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PlatformService } from '@rma/generic/util/environment';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'rma-blog-post-content',
  templateUrl: './post-content.component.html',
  styleUrls: ['./post-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [],
})
export class PostContentComponent implements AfterViewInit {
  @Input()
  public safeContent: SafeHtml;

  @ViewChild('blogSection')
  public blogSection: ElementRef;

  private isPlatformBrowser: boolean;

  public constructor(
    platformService: PlatformService,
    private readonly route: ActivatedRoute,
  ) {
    this.isPlatformBrowser = platformService.isPlatformBrowser;
  }

  public ngAfterViewInit(): void {
    // listen to any fragment change in route, then scroll to that location
    this.route.fragment.pipe(untilDestroyed(this)).subscribe((fragment: string) => this.scrollToAnchor(fragment));

    if (this.isPlatformBrowser && this.blogSection?.nativeElement) {
      fromEvent<{ target: { hash: string } }>(this.blogSection.nativeElement, 'click')
        .pipe(
          filter((event) => event.target.hash?.length > 0),
          map((event) => event.target.hash.replace('#', '')),
          untilDestroyed(this),
        )
        .subscribe((anchor) => this.scrollToAnchor(anchor));
    }
  }

  private scrollToAnchor(location: string): void {
    if (this.isPlatformBrowser) {
      const element = this.blogSection?.nativeElement?.querySelector(`#${location}`);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' }); // smooth scrolling, not jump
        });
      }
    }
  }
}
